var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgetpw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "46px",
    viewBox: "0 0 43 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "forgetpw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-1.8%",
    y: "-2.4%",
    width: "103.7%",
    height: "105.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "19.3-Speed-Bet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sprint-19.3.1-priority-access",
    transform: "translate(-781.000000, -783.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Key-Content",
    filter: "url(#filter-1)",
    transform: "translate(147.000000, 126.044423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(438.492537, 662.455577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forgetpw",
    transform: "translate(207.849616, 6.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3082,16.1967064 C8.92833754,16.1926915 8.59189626,15.9506042 8.4674,15.5917 C8.23908415,14.7589243 8.55982293,13.8726071 9.2682,13.3788 C9.44198435,13.2439872 9.62255381,13.1181559 9.8092,13.0018 C9.99727917,12.8928966 10.1720534,12.762487 10.33,12.6132 C10.5783342,12.3114593 10.628649,11.892898 10.4589,11.5409 C10.2510832,11.1582872 9.86123176,10.909314 9.4267,10.8817 C8.9942135,10.8533507 8.57298301,11.0269093 8.286,11.3517 C8.00460152,11.6788202 7.88712261,12.1161007 7.9667,12.5402 C8.06080931,13.0142812 7.75278122,13.4748907 7.2787,13.569 C6.80461877,13.6631093 6.34400933,13.3550812 6.2499,12.881 C6.06031396,11.9222095 6.32760759,10.92979 6.97308892,10.1959126 C7.61857024,9.46203525 8.5687527,9.07025017 9.5439,9.1359 C10.6015084,9.20702295 11.5445687,9.82697706 12.0292,10.7697 C12.516473,11.7703757 12.3534673,12.9659876 11.6161,13.7997 C11.3603828,14.0615041 11.0712172,14.2883982 10.7561,14.4745 C10.6211962,14.5571372 10.4908099,14.6469321 10.3655,14.7435 C10.2563367,14.8210058 10.1734965,14.9300519 10.1281,15.056 C10.2032968,15.2732417 10.1880394,15.5115888 10.0857572,15.7174696 C9.98347505,15.9233503 9.80274909,16.0794921 9.5842,16.1508 C9.49544542,16.1815498 9.40212972,16.1970686 9.3082,16.1967064 L9.3082,16.1967064 Z",
    id: "Path",
    fill: "#312F2E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#312F2E",
    cx: 9.3,
    cy: 17.5323,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37,6.01 L14.2,6.01 L14.2,3.7 C14.2,1.63 12.06,0 9.33,0 C6.6,0 4.46,1.63 4.46,3.7 L4.46,6.01 L2.29,6.01 C1.02859624,6.00861464 0.00413499176,7.02860226 0,8.29 L0,14.63 C0.0038583921,18.3839369 0.046063061,21.4261416 3.8,21.43 L14.86,21.43 C18.6139141,21.4260866 18.6560866,18.3839141 18.66,14.63 L18.66,8.29 C18.655865,7.02860226 17.6314038,6.00861464 16.37,6.01 Z M6.21,3.7 C6.21,2.64 7.64,1.75 9.33,1.75 C11.02,1.75 12.45,2.64 12.45,3.7 L12.45,6.01 L6.21,6.01 L6.21,3.7 Z M16.91,14.63 C16.9071338,17.4178499 17.6478499,19.6771338 14.86,19.68 L3.8,19.68 C2.03809703,19.68 1.74999566,16.9093961 1.74999566,14.63 L1.74999566,8.29 C1.75313276,7.99468569 1.99467872,7.7576128 2.29,7.75993008 L16.37,7.75993008 C16.6653213,7.7576128 16.9068672,7.99468569 16.91,8.29 L16.91,14.63 Z",
    id: "Shape",
    fill: "#32302F"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgetpw);
export default __webpack_public_path__ + "static/media/forgetpw.170bf48997eabfe8fb79b56716aadbca.svg";
export { ForwardRef as ReactComponent };